// extracted by mini-css-extract-plugin
export var logo = "_g9-2";
export var logoWrapper = "_g9-1";
export var strip = "_g9-0";